import  React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import AppMenuBarClusterRight from "./AppMenuBarClusterRight";
import AppMenuBarClusterLeft from "./AppMenuBarClusterLeft";
import AppMenuBarMenu from "./AppMenuBarMenu";
import AppMenuBarLogo from "./AppMenuBarLogo";
import {Stack, Typography} from "@mui/material";
import HelpIcon from '@mui/icons-material/Help';
import ConnieContractHelper from "../Connie/ConnieContractHelper";
export default function AppMenuBar(setIsAuthenticated) {

    const environment = import.meta.env.VITE_FRONTEND_URL;



    const hideActions = localStorage.getItem('rights') !== "Super User";

    // return (
    //
    //
    //     <Box sx={{ flexGrow: 1 }}>
    //         <AppBar position="static">
    //             <Toolbar>
    //
    //                 <AppMenuBarMenu/>
    //
    //                 <AppMenuBarClusterLeft/>
    //
    //                 <Box sx={{ flexGrow: 1 }}/>
    //
    //                 <AppMenuBarLogo/>
    //
    //                 <AppMenuBarClusterRight
    //                     setIsAuthenticated={setIsAuthenticated}
    //                     hideActions={hideActions}
    //                 />
    //
    //             </Toolbar>
    //         </AppBar>
    //     </Box>
    // );

    return (
        <Box sx={{ flexGrow: 1,

           }}>
            <AppBar position="static">
                <Toolbar
                    disableGutters
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr auto 1fr',
                        alignItems: 'center',
                        px: 1, // optional padding
                        // backgroundColor: environment === 'http://localhost:3000' ? 'purple' : 'inherit'
                        backgroundColor: environment === 'http://localhost:3000' ? 'skyblue' : 'inherit'
                    }}
                >
                    {/* Left cluster */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AppMenuBarMenu />
                        <AppMenuBarClusterLeft />
                        {/*<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{environment}</Typography>*/}

                    </Box>

                    {/* Center: always centered */}

                    <Box sx={{ justifySelf: 'center' }}>
                        <Stack direction="row" sx={{ alignItems: 'center' }} spacing={2}>
                        <AppMenuBarLogo />
                            <ConnieContractHelper />
                        </Stack>
                    </Box>

                    {/* Right cluster */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifySelf: 'end' }}>
                        <AppMenuBarClusterRight
                            setIsAuthenticated={setIsAuthenticated}
                            hideActions={hideActions}
                        />
                    </Box>
                </Toolbar>
            </AppBar>
        </Box>
    );



}
